<template>
    <div v-show="showLoginDialog">
        <!-- PC -->
        <van-popup class="pc-popup" v-model="pcLogin.showState" :close-on-click-overlay="false" get-container="body">
            <div class="container">
                <div class="title">
                    <img src="https://res.peki.vip/20220909/30cedc8ef14f4204b83ba2bda857ce49.png" />
                    <span>微信登录</span>
                </div>
                <div class="qrcode-box">
                    <img
                        v-show="pcLogin.qrcodeUrl"
                        :src="pcLogin.qrcodeUrl"
                        :style="`opacity: ${pcLogin.resetState ? '0.2' : '1'}`"
                        class="wx-qrcode"
                    />
                    <canvas
                        v-show="!pcLogin.qrcodeUrl"
                        :style="`opacity: ${pcLogin.resetState ? '0.2' : '1'}`"
                        class="wx-qrcode"
                        ref="wxQrcode"
                    />
                    <button @click.stop="onGetPcLoginQrcodeUrl" v-show="pcLogin.resetState" class="restart-btn">
                        刷新二维码
                    </button>
                </div>
                <div class="sub-title">请使用微信扫描二维码</div>
            </div>
        </van-popup>
        <!-- 移动端 微信 无UI 跳转登录 -->
        <!-- 移动端 非微信 + 绑定手机号 -->
        <van-popup
            class="mobile-popup"
            v-model="mobileLogin.showState"
            :close-on-click-overlay="false"
            get-container="body"
        >
            <div class="container">
                <div class="title" v-if="mobileLogin.purpose === 'login'">手机号登录</div>
                <div class="title" v-if="mobileLogin.purpose === 'bindTel'">绑定手机号</div>
                <div class="tel-code">
                    <div class="item">
                        <input v-model="mobileLogin.telNo" placeholder="请输入您的手机号" />
                    </div>
                    <div class="item">
                        <input v-model="mobileLogin.code" @input="onCodeChange" placeholder="请输入验证码" />
                        <div
                            class="code-btn"
                            :class="mobileLogin.hasGetCode ? '' : 'disabled-state'"
                            @click="onCheckTel"
                        >
                            {{ mobileLogin.hasGetCode ? '获取验证码' : `${mobileLogin.timeNum}s` }}
                        </div>
                    </div>
                    <div class="login-btn" @click="onLogin">登录</div>
                </div>
            </div>
        </van-popup>
        <van-popup class="kaptcha-popup" v-model="mobileLogin.showKaptchaState" get-container="body">
            <div class="container">
                <img
                    @click="onResetKaptchaRandom"
                    class="verification-img"
                    :src="`${mobileLogin.kaptchaUrl}${mobileLogin.telNo}&rd=${mobileLogin.kaptchaRandom}`"
                />
                <van-icon @click="onResetKaptchaRandom" name="replay" />
                <input v-model="mobileLogin.kaptchaCode" placeholder="请输入" />
            </div>
            <div class="opts">
                <div class="close-btn btn-style1" @click="mobileLogin.showKaptchaState = false">取消</div>
                <div class="submit-btn btn-style1" @click="onGetCaptcha">确认</div>
            </div>
        </van-popup>
    </div>
</template>
<script>
// 单独引入 防止其他地方没有引入
import { Popup, Icon } from 'vant'
import { urlQuery, isWeixin, isMobile } from '@/utils/utils.js'
import { getOAuthTpTicket, userLogin, getCaptcha, loginByCaptcha, userTelMod } from '@/utils/api.js'
import { getUserInfo, setUserInfo, wxLogin } from '@/utils/login.js'
const QRCode = require('qrcode')

export default {
    props: ['authTel', 'forceLoginType'],
    components: { VanPopup: Popup, VanIcon: Icon },
    data() {
        return {
            showLoginDialog: false,
            pcLogin: {
                showState: false,
                timer: 0,
                qrcodeUrl: '',
                resetState: false,
            },
            mobileLogin: {
                purpose: 'login',
                showState: false,
                timer: 0,
                timeNum: 60,
                telNo: '',
                code: '',
                hasGetCode: true,

                showKaptchaState: false,
                kaptchaUrl: `${window.SEVER_PATH}/user/getKaptcha?tel=`,
                kaptchaCode: '',
                kaptchaRandom: '',
            },
        }
    },
    created() {
        const userInfo = getUserInfo()
        if (userInfo) {
            this.showLoginDialog = false
            this.loginSuccess(userInfo, true)
        } else {
            this.showLoginDialog = true
        }
    },
    mounted() {
        if (!this.showLoginDialog) return

        // 强制使用某种登录方式
        if (this.forceLoginType === 'wechat') {
            this.wechatLogin()
        } else if (this.forceLoginType === 'tel') {
            this.mobileLogin.showState = true
        } else if (this.forceLoginType === 'wechatScan') {
            this.pcLogin.showState = true
            this.onGetPcLoginQrcodeUrl()
        } else {
            // 根据环境切换登录方式
            if (isWeixin()) {
                this.wechatLogin()
            } else if (!isMobile()) {
                this.pcLogin.showState = true
                this.onGetPcLoginQrcodeUrl()
            } else {
                this.mobileLogin.showState = true
            }
        }
    },
    methods: {
        // 微信登录
        wechatLogin() {
            // 移动端 微信
            // isLoginState 防止用户带有复制的 tpTicket 打开页面
            const options = urlQuery()
            const state = window.localStorage.getItem('isLoginState')
            if (!state) options.tpTicket = ''
            if (options.tpTicket) {
                this.loginByAuthTicketApi(options.tpTicket)
                window.localStorage.removeItem('isLoginState')
            } else {
                this.getOAuthTpTicketApi()
            }
        },
        // 登录成功
        // authTel 检验手机号
        loginSuccess(data, isHistoryLoginData) {
            if (this.authTel && !data.telNo) {
                this.mobileLogin.purpose = 'bindTel'
                this.mobileLogin.showState = true
                this.pcLogin.showState = false
                this.temporaryUser = data
                return
            }
            if (!isHistoryLoginData) {
                this.$toast.success('登录成功')
            }
            setUserInfo(data)
            this.showLoginDialog = false
            this.pcLogin.showState = false
            this.mobileLogin.showState = false
            this.mobileLogin.showKaptchaState = false
            this.$emit('change', data)
            // 重定向清空登录信息
            this.$nextTick(() => {
                this.clearLoginTpTicket()
            })
        },
        onGetPcLoginQrcodeUrl() {
            this.pcLogin.resetState = false
            getOAuthTpTicket({ type: 'OAUTH_H5' }).then((res) => {
                QRCode.toCanvas(
                    this.$refs.wxQrcode,
                    res.data.authUrl,
                    { width: 260, height: 260, margin: 2, errorCorrectionLevel: 'L' },
                    () => {}
                )
                let timeNum = 0
                clearInterval(this.pcLogin.timer)
                this.pcLogin.timer = setInterval(() => {
                    userLogin({ type: 'auth_ticket', authTicket: res.data.tpTicket }).then((u) => {
                        const user = u.data
                        if (user) {
                            clearInterval(this.pcLogin.timer)
                            this.loginSuccess(user)
                        }
                    })
                    timeNum += 3
                    if (timeNum >= 5 * 60) {
                        clearInterval(this.pcLogin.timer)
                        this.pcLogin.resetState = true
                        this.$toast('二维码已过期')
                    }
                }, 3000)
            })
        },

        // 微信登录
        getOAuthTpTicketApi() {
            getOAuthTpTicket({ type: 'OAUTH_H5' }).then((res) => {
                window.localStorage.setItem('isLoginState', true)
                wxLogin(res.data.tpTicket)
            })
        },
        loginByAuthTicketApi(tpTicket) {
            userLogin({ type: 'auth_ticket', authTicket: tpTicket, appId: window.WX_APPID }).then((res) => {
                const user = res.data
                if (user) {
                    this.loginSuccess(user)
                } else {
                    this.$toast('登录失败')
                }
            })
        },

        // 手机号登录
        onCheckTel() {
            const rule = new RegExp(/^1[0-9]{10}$/)
            if (!rule.test(this.mobileLogin.telNo)) {
                return this.$toast('请输入正确的手机号')
            }
            if (!this.mobileLogin.hasGetCode) return
            this.mobileLogin.showKaptchaState = true
            this.mobileLogin.kaptchaCode = ''
            this.onResetKaptchaRandom()
        },
        onCodeChange() {
            this.mobileLogin.code = this.mobileLogin.code.substr(0, 6)
        },
        onResetKaptchaRandom() {
            this.mobileLogin.kaptchaRandom = parseInt(Math.random() * 10000)
        },
        onGetCaptcha() {
            getCaptcha({ tel: this.mobileLogin.telNo, kaptcha: this.mobileLogin.kaptchaCode }).then(() => {
                this.mobileLogin.showKaptchaState = false
                this.$toast.success('发送成功')
                this.mobileLogin.hasGetCode = false
                this.mobileLogin.timer = setInterval(() => {
                    this.mobileLogin.timeNum -= 1
                    if (this.mobileLogin.timeNum <= 0) {
                        clearInterval(this.mobileLogin.timer)
                        this.mobileLogin.timer = null
                        this.mobileLogin.hasGetCode = true
                        this.mobileLogin.timeNum = 60
                    }
                }, 1000)
            })
        },
        onLogin() {
            const ruleTel = new RegExp(/^1[0-9]{10}$/)
            const ruleCode = new RegExp(/^[0-9]{4,8}$/)
            if (!ruleTel.test(this.mobileLogin.telNo)) {
                return this.$toast('请输入正确的手机号')
            } else if (!ruleCode.test(this.mobileLogin.code)) {
                return this.$toast('请输入正确的验证码')
            }

            if (this.mobileLogin.purpose === 'bindTel') {
                userTelMod({
                    userId: this.temporaryUser.id,
                    telNo: this.mobileLogin.telNo,
                    captcha: this.mobileLogin.code,
                    token: this.temporaryUser.token,
                }).then(() => {
                    this.temporaryUser.telNo = this.mobileLogin.telNo
                    this.loginSuccess(this.temporaryUser)
                    this.mobileLogin.showKaptchaState = false
                    this.mobileLogin.showState = false
                })
            } else if (this.mobileLogin.purpose === 'login') {
                loginByCaptcha({ tel: this.mobileLogin.telNo, captcha: this.mobileLogin.code }).then((res) => {
                    this.loginSuccess(res.data)
                    this.mobileLogin.showKaptchaState = false
                    this.mobileLogin.showState = false
                })
            }
        },

        clearLoginTpTicket() {
            const options = urlQuery()
            if (options.tpTicket) {
                const { origin, pathname } = window.location
                delete options.tpTicket
                let url = `${origin}${pathname}`
                if (Object.keys(options).length !== 0) {
                    const arr = []
                    Object.keys(options).forEach((key) => {
                        arr.push(`${key}=${options[key]}`)
                    })
                    url += '?' + arr.join('&')
                }
                window.location.href = url
            }
        },
    },
}
</script>
<style lang="scss" scoped>
.pc-popup {
    border-radius: 10px;
    .container {
        width: 300px;
        height: 360px;
        background: #fff;
    }
    .title {
        display: flex;
        align-items: center;
        font-size: 18px;
        font-weight: 700;
        height: 50px;
        padding-left: 30px;
        border-bottom: 2px solid #eee;
        img {
            width: 30px;
            height: 30px;
            margin-right: 10px;
        }
    }
    .qrcode-box {
        width: 260px;
        height: 260px;
        position: relative;
        margin: 10px auto 0;
        .wx-qrcode {
            width: 260px;
            height: 260px;
        }
    }
    .restart-btn {
        font-size: 14px;
        border: none;
        background: #666;
        color: #fff;
        line-height: 30px;
        width: 120px;
        border-radius: 4px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        cursor: pointer;
    }
    .qrcode {
        width: 260px;
        height: 260px;
    }
    .sub-title {
        font-size: 14px;
        color: #aaa;
        text-align: center;
        line-height: 1.4em;
    }
    .sub-title-color {
        color: #555;
        font-weight: 700;
    }
}
</style>
<style lang="scss" scoped>
.mobile-popup {
    .container {
        width: 300px;
        height: 280px;
        .title {
            text-align: center;
            line-height: 3em;
            font-size: 20px;
            font-weight: 700;
        }
        .tel-code {
            margin-top: 12px;
            padding: 0 24px;
            .item {
                background: #f5f5f5;
                border-radius: 4px;
                border: 1px solid #e6e6e6;
                font-size: 16px;
                line-height: 16px;
                display: flex;
                align-items: center;
                position: relative;
                box-sizing: border-box;
                width: 252px;
                height: 36px;
                margin-bottom: 24px;
                padding: 0 16px;
            }
            input {
                background: #f5f5f5;
                border: none;
                width: 60%;
                color: #333333;
                font-size: 14px;
                line-height: 14px;
            }
            .code-btn {
                width: 80px;
                height: 36px;
                background: #44cd94;
                border-radius: 0px 4px 4px 0px;
                font-size: 13px;
                color: #ffffff;
                line-height: 14px;
                position: absolute;
                display: flex;
                justify-content: center;
                align-items: center;
                right: 0;
                top: 0;
                cursor: pointer;
            }
            .disabled-state {
                color: #666666;
                background: #eeeeee;
            }
            .login-btn:active {
                opacity: 0.9;
            }
            .login-btn {
                background: #ffffff;
                color: #ffffff;
                background: #44cd94;
                display: flex;
                justify-content: center;
                align-items: center;
                width: 240px;
                height: 36px;
                border-radius: 4px;
                font-weight: 700;
                font-size: 16px;
                margin: 36px auto 24px;
            }
        }
        .agm {
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 14px;
            color: #99948d;
            line-height: 20px;
            a {
                color: #2440b3;
            }
        }
    }
}
.kaptcha-popup {
    width: 280px;
    height: 180px;
    border-radius: 4px;
    .container {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 36px auto 10px;
        .verification-img {
            width: 100px;
            height: 40px;
            margin-right: 10px;
        }
        .van-icon-replay {
            cursor: pointer;
            font-size: 18px;
        }
        input {
            margin-left: 24px;
            height: 28px;
            width: 80px;
            border: 1px solid #dedede;
            display: block;
            border-radius: 4px;
            padding: 4px 8px;
            text-align: center;
        }
    }

    .opts {
        display: flex;
        justify-content: space-between;
        padding: 28px 40px 0;
        > div {
            width: 90px;
            height: 28px;
            border-radius: 4px;
            font-size: 13px;
            font-weight: 500;
            color: #ffffff;
            line-height: 20px;
            box-sizing: border-box;
            margin: 0 auto;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .close-btn {
            border: 1px solid #e6e6e6;
            background: #ffffff;
            color: #606266;
        }
        .submit-btn {
            color: #ffffff;
            background: #44cd94;
        }
    }
}
</style>
